import { render } from "./iOSDownload.vue?vue&type=template&id=fee18f16&scoped=true"
import script from "./iOSDownload.vue?vue&type=script&lang=js"
export * from "./iOSDownload.vue?vue&type=script&lang=js"

import "./iOSDownload.vue?vue&type=style&index=0&id=fee18f16&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fee18f16"]])

export default __exports__